import { useMutation, useQueryClient } from "react-query";

import { crearDropoff, updateDropoff, deleteDropoff} from '../../services/dropoff';

import { toast } from 'react-hot-toast';
const queryKey = "recolectores";

export const useDropMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addDrop = useMutation((body) => crearDropoff(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateDropD = useMutation(
    (body) => updateDropoff( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeDrop = useMutation((id) => deleteDropoff( id), {
    onSuccess,
    onError,
  });

  return { addDrop, updateDropD, removeDrop };
};
export default useDropMutations;